import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export const SuprCtr = ({ setSuprCtr, idSelected }) => {
  const apiUrl = process.env.REACT_APP_API_URL;

   const [openSnackbar, setOpenSnackbar] = useState(false);
   const [message, setMessage] = useState("");

  const handleConfirm = () => {
    try {
      axios
        .post(`${apiUrl}IHM/api/contrat.php?idSupr=${idSelected}`)
        .then((response) => {
         
          setMessage(`Contrat supprimé avec succès`);
          setOpenSnackbar(true);

          setTimeout(() => {
            setSuprCtr(false);
            window.location.reload();
          }, 1500);
        })
        .catch((error) => {
         
        });
    } catch (error) {
     
    }
  };

  const handleCancel = () => {
   setMessage(`Suppression du contrat annulée`);
    setOpenSnackbar(true);

    setTimeout(() => {
      setSuprCtr(false);
    }, 1000);
  };

  const header = (
    <div className="flex justify-content-between align-items-center w-full">
      <span className="font-semibold text-lg" style={{ color: "#dc2626" }}>
        Supprimer le contrat
      </span>
    </div>
  );

   const handleCloseSnackbar = () => {
    setMessage("");
    setOpenSnackbar(false);
  };


  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message={message}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <Dialog
        blockScroll
        visible={true}
        header={header}
        className="custom-dialog"
        style={{ width: "40vw", maxWidth: "500px" }}
        modal
        onHide={() => setSuprCtr(false)}
        breakpoints={{ "960px": "90vw", "640px": "95vw" }}
      >
        <div className="p-3">
          <div className="grid">
            <div className="col-12">
              <p
                style={{
                  fontSize: "15px",
                  color: "#374151",
                  textAlign: "center",
                  marginBottom: "10px",
                }}
              >
                Voulez-vous vraiment supprimer le contrat{" "}
                <strong>n° {idSelected}</strong> ?
              </p>
              <p
                style={{
                  fontSize: "13px",
                  color: "#6b7280",
                  textAlign: "center",
                  marginBottom: "30px",
                }}
              >
                Cette action est irréversible.
              </p>
            </div>
          </div>

          <div className="grid">
            <div className="col-12">
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "center",
                }}
              >
                <Button
                  label="Annuler"
                  icon="pi pi-times"
                  className="p-button-text"
                  style={{
                    padding: "10px 30px",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#6b7280",
                    border: "1px solid #d1d5db",
                    background: "white",
                  }}
                  onClick={handleCancel}
                />
                <Button
                  label="Supprimer"
                  icon="pi pi-trash"
                  style={{
                    background: "#dc2626",
                    border: "none",
                    padding: "10px 30px",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "white",
                  }}
                  onClick={handleConfirm}
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};